var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ width: this.show },attrs:{"id":"app"},on:{"touchstart":function($event){$event.stopPropagation();return _vm.handleTouchStart.apply(null, arguments)},"touchend":function($event){$event.stopPropagation();return _vm.handleTouchEnd.apply(null, arguments)}}},[_c('router-view',{attrs:{"showpc":_vm.show}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc480946","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 